module.exports = __webpack_public_path__ + "static/media/Dubrovnik_Crotia_3.880a5557.jpg";